import { combineReducers } from 'redux'

import resultados from './detalhesLicitacao'
import itensLicitacao from './itensLicitacao'
import vencedoresLicitacao from './vencedoresLicitacao'
import vencedoresDetalhesLicitacao from './vencedoresDetalhesLicitacao'
import eventosLicitacao from './eventosLicitacao'
import contratoLicitacao from './contratoLicitacao'
import empenhosLicitacao from './empenhosLicitacao'
import questionamentosLicitacao from './questionamentosLicitacao'
import participantesLicitacao from './participantesLicitacao'
import itensLicitacaoDispensa from './itensLicitacaoDispensa'

export default combineReducers({
    resultados,
    itensLicitacao,
    itensLicitacaoDispensa,
    vencedoresLicitacao,
    participantesLicitacao,
    vencedoresDetalhesLicitacao,
    eventosLicitacao,
    contratoLicitacao,
    empenhosLicitacao,
    questionamentosLicitacao,
})
